import FileInput from './file_input';

export default FileInput;
